import React, { useEffect } from 'react'

import { BuildingEnergyRatingType } from '../../../../../../@types/types'
import { EnergyCertificateProps } from './EnergyCertificate'
import { InitState } from '../../../../../../redux/reducers/root/initialState'
import EfficiencyClassField from '../fields/efficiencyClassField/EfficiencyClassField'
import BuildingEnergyRatingTypeField from '../fields/buildingEnergyRatingTypeField/BuildingEnergyRatingTypeField'
import ConsumptionContainsWarmWaterField from '../fields/consumptionContainsWarmWaterField/ConsumptionContainsWarmWaterField'
import ThermalCharacteristicField from '../fields/thermalCharacteristicField/ThermalCharacteristicField'
import LegalConstructionYearField from '../fields/legalConstructionYearField/LegalConstructionYearField'
import GetThermalCharacteristicInputLabel from './GetThermalCharacteristicInputLabel'
import { useAppSelector } from '../../../../../../app/hooks'
import { ScreenName } from '../../../../../../services/domain/wizardScreens'
import { isWebView } from '../../../../../../utils/navigation'

const screenName: ScreenName = 'construction'

const EnergyCertificateAvailable: React.FC<EnergyCertificateProps> = ({
  screenId,
  insertionData,
  validators,
  onEnergyCertificateChange,
}) => {
  const isMobileView = isWebView()

  const props = {
    insertionData,
    screenName,
    screenId,
    onEnergyCertificateChange,
  }

  const isInternationalAddress: boolean = useAppSelector(
    (state: InitState) => state.addressFeature.isInternationalAddress
  )
  const showThermalCharacteristic = insertionData.buildingEnergyRatingType !== undefined

  const showEfficiencyClass = insertionData.buildingEnergyRatingType !== undefined

  const showConsumptionContainsWarmWater =
    isInternationalAddress && insertionData.buildingEnergyRatingType === BuildingEnergyRatingType.ENERGY_CONSUMPTION

  useEffect(() => {
    if (!insertionData.legalConstructionYear) {
      props.onEnergyCertificateChange('legalConstructionYear', insertionData.constructionYear)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      <LegalConstructionYearField
        {...props}
        validators={validators}
        wrapperClassName={
          isMobileView
            ? 'grid-item one-whole margin-top-m'
            : 'grid-item one-whole desk-one-half lap-four-fifth margin-top-m'
        }
      />
      <BuildingEnergyRatingTypeField {...props} />
      {showThermalCharacteristic && (
        <ThermalCharacteristicField
          {...props}
          validators={validators}
          isInternationalAddress={isInternationalAddress}
          thermalCharacteristicInputLabel={
            <GetThermalCharacteristicInputLabel buildingEnergyRatingType={insertionData.buildingEnergyRatingType} />
          }
          wrapperClassName={
            isMobileView
              ? 'grid-item one-whole margin-top-l'
              : 'grid-item one-whole desk-seven-twelfths lap-three-fifth margin-top-l'
          }
        />
      )}
      {showEfficiencyClass && (
        <EfficiencyClassField
          {...props}
          wrapperClassName={isMobileView ? 'grid-item one-whole margin-top-l' : 'grid-item four-fifth margin-top-l'}
        />
      )}
      {showConsumptionContainsWarmWater && <ConsumptionContainsWarmWaterField {...props} />}
    </>
  )
}

export default EnergyCertificateAvailable
